import { render, staticRenderFns } from "./modal-managetags.vue?vue&type=template&id=f8458d10&scoped=true&"
import script from "./modal-managetags.vue?vue&type=script&lang=js&"
export * from "./modal-managetags.vue?vue&type=script&lang=js&"
import style0 from "./modal-managetags.vue?vue&type=style&index=0&id=f8458d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8458d10",
  null
  
)

export default component.exports